(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.MapsConversionMatrixService = (function(superClass) {
    extend(MapsConversionMatrixService, superClass);

    function MapsConversionMatrixService(http) {
      this.http = http;
      this.confirm = bind(this.confirm, this);
      this.getImage = bind(this.getImage, this);
      this.checkUnconfirmed = bind(this.checkUnconfirmed, this);
      void 0;
    }

    MapsConversionMatrixService.prototype.checkUnconfirmed = function() {
      return this.http.post('backend/grower/maps-conversion/check-unconfirmed');
    };

    MapsConversionMatrixService.prototype.getImage = function(path) {
      return this.http.post('backend/grower/maps-conversion/view-image', {
        path: path
      });
    };

    MapsConversionMatrixService.prototype.confirm = function(parentsId, ingredion_survey) {
      return this.http.post('backend/grower/maps-conversion/confirm', {
        parentsId: parentsId,
        ingredion_survey: ingredion_survey
      });
    };

    return MapsConversionMatrixService;

  })(Service);

}).call(this);
